import gate from '@/api/axios';

export const serviceCategories = async () => gate.get('/serviceCategories');

export const countries = async () => gate.get('/countries');

export const regions = async (id) => gate.get(`/regions/${id}`);

export const districts = async (regionId) => gate.get(
  `/districts/${encodeURIComponent(regionId)}`,
);

export const contractorDemandStatus = async ({ regionId, categoryIds = [] }) => {
  const params = new URLSearchParams();

  params.append('region_id', regionId);

  if (categoryIds.length) {
    params.append('category_ids', categoryIds.join(','));
  }

  return gate.get(`/contractor/demand-status?${params.toString()}`);
};
